import { useQuery } from '@apollo/client';
import { ORGANIZATION_SETTINGS_QUERY } from './organizationSettingsQuery';

/**
 * The organization's product description template, read from Apollo. Like `useSalesOrderDocumentPrefix`,
 * it reads the app-wide settings document from the cache only (RoutesBridge's read fills it), so no
 * page starts a request of its own. Undefined until that read answers, as the store was.
 */
export function useProductDescriptionTemplate(): string | null | undefined {
  const { data } = useQuery(ORGANIZATION_SETTINGS_QUERY, { fetchPolicy: 'cache-only' });

  return data?.organization?.productDescriptionTemplate;
}
